var map = {
	"./Fungi_penicillum_02.jpg": 8649,
	"./Fungi_penicillum_03.jpg": 9398,
	"./Fungi_penicillum_04.jpg": 1568,
	"./Fungi_penicillum_05.jpg": 6219,
	"./Fungi_penicillum_06.jpg": 5429,
	"./Fungi_penicillum_08.jpg": 4947,
	"./Fungi_penicillum_09.jpg": 6555,
	"./Fungi_penicillum_10.jpg": 5886,
	"./Fungi_penicillum_11.jpg": 5624,
	"./Penicillum_03.jpg": 5235,
	"./Penicillum_04.jpg": 2505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9413;